import styled from 'styled-components';
import { color, ColorProps, typography, TypographyProps, variant } from 'styled-system';

type TextProps = ColorProps & TypographyProps & { variant?: string };

const textVariants = variant({
  variants: {
    body: {
      fontSize: 2,
    },
    label: {
      fontSize: 3,
    },
    header: {
      fontSize: 4,
    },
  },
});
const Text = styled.p<TextProps>`
  ${color}
  ${typography}
  ${textVariants}
`;

Text.defaultProps = {
  variant: 'body',
};

export default Text;
